import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select-legacy';
import { isEmpty, trim } from 'lodash';

const arrowRenderer = () => (
  <i className="sp-icon-search o-search__icon"></i>
);

class Search extends React.Component {
  constructor(props) {
    super(props);
    this.onInputChange = this.onInputChange.bind(this);
  }

  onInputChange(inputValue) {
    if (!isEmpty(trim(inputValue))) this.props.onFilter(inputValue);
    return inputValue;
  }

  render() {
    const { value, options, placeholder, filterOptions, onChange, disabled } = this.props;
    return (
      <Select
        name='sp-seach-select'
        arrowRenderer={arrowRenderer}
        className={'o-select'}
        filterOptions={filterOptions}
        value={value || ''}
        onInputChange={this.onInputChange}
        onChange={onChange}
        options={options || []}
        matchPos='any'
        placeholder={placeholder || 'Search...'}
        disabled={disabled}
      />
    );
  }
}

Search.propTypes = {
  filterOptions: PropTypes.func.isRequired,
  value: PropTypes.number,
  options: PropTypes.arrayOf(PropTypes.object),
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onFilter: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}

export default Search;
